<template>
  <Loader v-if="loader"/>
  <DataTable :value="itemsBonus" ref="dtBonus" :exportFilename="nome_dt_bonus"  paginator :rows="25" :rowsPerPageOptions="[25, 50, 100, 250, 500]">
    <template #header>
        <h3>Bonus Gas BASILICATA</h3>
        <div class="flex align-items-center">
          <label class="m-2">Data bonus</label>
          <Calendar class="m-2" v-model="selectedDataBonus" dateFormat="mm/yy" view="month" :maxDate="maxDateBonus" :manualInput="false"/>
          <Button @click="getDataBonus()" icon="pi pi-search" class="p-button-primary" label="Cerca"/>
        </div>
        <div style="text-align: left">
          <Button v-if="itemsBonus.length > 0" icon="pi pi-external-link" label="Export" @click="exportCSV('dtBonus')" />
        </div>
    </template>
    <Column v-for="(col, index) of columnsBonus" :key="index" :field="col" :header="col"></Column>
  </DataTable>
  <Card class="mt-3">
    <template #title>Elabora risposta Bonus Basilicata</template>
    <template #content>
      <div class="flex align-items-center flex-wrap">
        <label class="m-2">Mensilita'</label>
        <Calendar
          class="m-2"
          v-model="selectedDataRispostaBonus"
          dateFormat="mm/yy"
          view="month"
          :maxDate="maxDateRispostaBonus"
          :manualInput="false"
        />
        <FileUpload
          v-if="bonusRispostaImportato === false"
          :key="bonusRispostaUploadKey"
          mode="basic"
          name="file"
          chooseLabel="Carica risposta"
          chooseIcon="pi pi-upload"
          accept="text/csv,.csv"
          customUpload
          :auto="true"
          :disabled="loader"
          @uploader="uploadBonusRisposta"
        />
        <Button
          v-if="bonusRispostaImportato === true"
          icon="pi pi-download"
          label="Scarica BB"
          class="p-button-success m-2"
          :disabled="loader"
          @click="downloadBonusRisposta"
        />
      </div>
      <small class="block mt-2">
        File atteso: {{ nome_file_risposta_bonus }}.csv
      </small>
    </template>
  </Card>
  <Card>
    <template #title>Fatture emesse</template>
    <template #content>
      <div class="flex align-items-center">
        <label class="m-2">Data emissione</label>
        <Calendar class="m-2" v-model="selectedDataEmissione" dateFormat="mm/yy" view="month" :maxDate="maxDate" :manualInput="false"/>
        <Checkbox v-model="includeConsumi" :binary="true" class="ml-2" />
        <label class="ml-2">includi consumi</label>
        <Button @click="getDataFatture()" icon="pi pi-search" class="p-button-primary ml-2" label="Cerca"/>
      </div>
      <DataTable v-if="itemsFatture.length > 0" :value="itemsFatture" ref="dtFatture" :exportFilename="nome_dt_fatture" paginator :rows="25" :rowsPerPageOptions="[25, 50, 100, 250, 500]">
        <template #header>
          <h3>Fatture Bonus del {{ moment(selectedDataEmissione).format('DD-MM-YYYY') }}</h3>
          <div style="text-align: left">
            <Button icon="pi pi-external-link" label="Export" @click="exportCSV('dtFatture')" />
            <Button
              icon="pi pi-download"
              label="Scarica zip Fatture"
              class="p-button-success ml-2"
              :disabled="itemsFatture.length === 0"
              @click="downloadFattureZip()"
            />
            <Button
              icon="pi pi-file-pdf"
              label="Scarica zip Dettaglio esteso"
              class="p-button-info ml-2"
              :disabled="itemsFatture.length === 0"
              @click="downloadFattureEsteseZip()"
            />
          </div>
        </template>
        <Column header="Azioni" :exportable="false">
          <template #body="{ data }">
            <Button
              icon="pi pi-eye"
              class="p-button-rounded p-button-success"
              v-tooltip.top="'Visualizza fattura'"
              aria-label="Visualizza fattura"
              :disabled="!getInvoiceNumber(data)"
              @click="openFatturaPdf(data)"
            />
          </template>
        </Column>
        <Column v-for="(col, index) of columnsFatture" :key="index" :field="col" :header="col"></Column>
      </DataTable>
    </template>
  </Card>
</template>

<script>
  import UtilityService from '@/services/ask-management/utility-service'
  import FattureClientiService from '@/services/ask-management/fatture-clienti-service'
  import { ref, onMounted, getCurrentInstance, computed, watch } from 'vue';
  import Checkbox from 'primevue/checkbox'
  import Loader from '@/components/Loader.vue'
  import moment from 'moment';

  export default {
    components: {
      Loader,
      Checkbox
    },
    setup() {
      const loader = ref(false);
      const self = getCurrentInstance();
      self.$eventBus = self.appContext.config.globalProperties.$eventBus
      self.$http = self.appContext.config.globalProperties.$http
      const toast = self.proxy.$toast
      const utilityService = new UtilityService(self.$http, self.$eventBus)
      const fattureClientiService = new FattureClientiService(self.$http, self.$eventBus)
      const itemsBonus = ref([]);
      const columnsBonus = ref([]);

      const itemsFatture = ref([]);
      const columnsFatture = ref([]);

      const dtBonus = ref();
      const dtFatture = ref();

      const selectedDataEmissione = ref()
      const includeConsumi = ref(false)
      const selectedDataBonus = ref()
      const selectedDataRispostaBonus = ref()
      const maxDate = ref()
      const maxDateBonus = ref()
      const maxDateRispostaBonus = ref()
      const bonusRispostaUploadKey = ref(0)
      const bonusRispostaImportato = ref(null)
      const nome_dt_fatture = computed(() => {
        let nome = 'F2_'
        if(selectedDataEmissione.value) nome += moment(selectedDataEmissione.value).format('YYYY_MM')
        return nome
      })

      const nome_dt_bonus = computed(() => {
        return 'F1_' + moment(selectedDataBonus.value).format('YYYY_MM')
      })

      const nome_file_risposta_bonus = computed(() => {
        return 'RISPOSTA_F1_' + moment(selectedDataRispostaBonus.value).format('YYYY_MM')
      })

      onMounted(() => {
        maxDate.value = new Date(moment().endOf('month'))
        maxDateBonus.value = new Date(moment().endOf('month'))
        maxDateRispostaBonus.value = new Date(moment().subtract(2, 'month').endOf('month'))
        selectedDataEmissione.value = new Date(moment().subtract(1, 'month').startOf('month'))
        selectedDataBonus.value = new Date()
        selectedDataRispostaBonus.value = new Date(moment().subtract(2, 'month').startOf('month'))
        getDataBonus()
      })

      watch(selectedDataRispostaBonus, () => {
        checkBonusRispostaImportata()
      })

      const getDataBonus = async () => {
        loader.value = true;
        await utilityService.getBonus(19, moment(selectedDataBonus.value).endOf('month').format('YYYY-MM-DD'))
        .then((res) => {
          itemsBonus.value = res.items.data
          columnsBonus.value = res.items.columns           
        }).finally(() => {
            loader.value = false;
        })
      }

      const getDataFatture = async () => {        
        loader.value = true;
        await utilityService.getFattureBonus(
          moment(selectedDataEmissione.value).format('YYYY-MM-DD'),
          includeConsumi.value
        )
        .then((res) => {
          itemsFatture.value = res.items.data
          columnsFatture.value = res.items.columns           
        }).finally(() => {
            loader.value = false;
        })
      }

      const getRowValue = (row, keys) => {
        const key = keys.find((candidate) => row[candidate] !== undefined && row[candidate] !== null && row[candidate] !== '')
        return key ? row[key] : null
      }

      const getInvoiceNumber = (row) => {
        return getRowValue(row, ['Numero_fattura', 'numero_fattura', 'numero', 'NUMERO_FATTURA', 'NUMERO', 'Numero Fattura'])
      }

      const getInvoiceEmissionDate = (row) => {
        return getRowValue(row, ['data_emissione', 'DATA_EMISSIONE', 'Data Emissione'])
      }

      const openFatturaPdf = async (row) => {
        const numeroFattura = getInvoiceNumber(row)
        if (!numeroFattura) return

        loader.value = true
        try {
          await fattureClientiService.openFatturaPdf(numeroFattura, getInvoiceEmissionDate(row))
        } finally {
          loader.value = false
        }
      }

      const getFattureZipFilename = () => {
        return `FATT_${moment(selectedDataEmissione.value).format('MM_YYYY')}.zip`
      }

      const getFattureEsteseZipFilename = () => {
        return `FATT_DETTAGLIO_ESTESO_${moment(selectedDataEmissione.value).format('MM_YYYY')}.zip`
      }

      const getInvoiceNumbersFromTable = () => {
        return itemsFatture.value
          .map((row) => getInvoiceNumber(row))
          .filter((numero) => numero !== null && numero !== undefined && numero !== '')
      }

      const downloadFattureZip = async () => {
        const numeriFattura = getInvoiceNumbersFromTable()

        if (numeriFattura.length === 0) return

        loader.value = true
        try {
          await fattureClientiService.downloadFattureZip(numeriFattura, getFattureZipFilename())
        } finally {
          loader.value = false
        }
      }

      const downloadFattureEsteseZip = async () => {
        const numeriFattura = getInvoiceNumbersFromTable()

        if (numeriFattura.length === 0) return

        loader.value = true
        try {
          await fattureClientiService.downloadFattureEsteseZip(numeriFattura, getFattureEsteseZipFilename())
        } finally {
          loader.value = false
        }
      }

      const showToast = (severity, summary, detail, life = 5000) => {
        toast.add({ severity, summary, detail, life })
      }

      const normalizePdr = (value) => {
        return String(value ?? '').trim()
      }

      const getBonusRispostaPdrSet = async () => {
        const res = await utilityService.getBonus(19, getBonusRispostaDate().endOf('month').format('YYYY-MM-DD'))
        const rows = res?.items?.data || []

        return new Set(
          rows
            .map(row => normalizePdr(row.PDR))
            .filter(Boolean)
        )
      }

      const getFileBaseName = (fileName) => {
        return String(fileName || '').replace(/\.[^.]+$/, '')
      }

      const getFileExtension = (fileName) => {
        const parts = String(fileName || '').split('.')
        return parts.length > 1 ? parts.pop().toLowerCase() : ''
      }

      const getBonusRispostaDate = () => {
        return moment(selectedDataRispostaBonus.value).startOf('month')
      }

      const validateBonusRispostaDate = () => {
        const selected = getBonusRispostaDate()
        const max = moment(maxDateRispostaBonus.value).startOf('month')
        return selected.isValid() && selected.isSameOrBefore(max, 'month')
      }

      const checkBonusRispostaImportata = async () => {
        bonusRispostaImportato.value = null

        if (!selectedDataRispostaBonus.value || !validateBonusRispostaDate()) {
          return
        }

        try {
          const res = await utilityService.checkFileBonusBasilicataRisposta(getBonusRispostaDate().format('YYYY-MM-DD'))
          bonusRispostaImportato.value = res.importato === true
        } catch (err) {
          const responseData = err?.response?.data
          showToast('warn', 'Errore', responseData?.message || 'Impossibile verificare lo stato del file risposta.')
        }
      }

      const parseCsvLine = (line) => {
        const values = []
        let value = ''
        let quoted = false

        for (let i = 0; i < line.length; i++) {
          const char = line[i]
          const nextChar = line[i + 1]

          if (char === '"' && quoted && nextChar === '"') {
            value += '"'
            i += 1
          } else if (char === '"') {
            quoted = !quoted
          } else if (char === ';' && !quoted) {
            values.push(value)
            value = ''
          } else {
            value += char
          }
        }

        values.push(value)
        return values
      }

      const readBonusRispostaPdrs = async (file) => {
        const text = await file.text()
        const rows = text
          .replace(/^\uFEFF/, '')
          .split(/\r\n|\n|\r/)
          .filter(row => row.trim() !== '')

        return rows
          .slice(1)
          .map(row => normalizePdr(parseCsvLine(row)?.[0]))
          .filter(Boolean)
      }

      const uploadBonusRisposta = async (event) => {
        const file = event?.files?.[0]

        if (!file) return

        try {
          if (!validateBonusRispostaDate()) {
            showToast('warn', 'Mensilita non valida', 'La mensilita puo arrivare al massimo al mese corrente meno due mesi.')
            return
          }

          const expectedName = nome_file_risposta_bonus.value
          if (getFileBaseName(file.name) !== expectedName) {
            showToast('warn', 'Nome file non valido', `Il file deve chiamarsi ${expectedName}.csv.`)
            return
          }

          if (getFileExtension(file.name) !== 'csv') {
            showToast('warn', 'Formato file non valido', 'Il file risposta deve essere un csv con separatore ";".')
            return
          }

          const pdrs = await readBonusRispostaPdrs(file)
          if (pdrs.length === 0) {
            showToast('warn', 'File vuoto', 'La prima colonna del file non contiene PDR da elaborare.')
            return
          }

          loader.value = true
          const pdrSet = await getBonusRispostaPdrSet()
          if (pdrSet.size === 0) {
            showToast('warn', 'Lista bonus vuota', 'Nessun PDR bonus trovato per la mensilita selezionata.')
            return
          }

          const missingPdrs = [...new Set(pdrs.filter(pdr => !pdrSet.has(pdr)))]

          if (missingPdrs.length > 0) {
            showToast(
              'warn',
              'PDR non presenti',
              `PDR non trovati nella tabella bonus: ${missingPdrs.slice(0, 10).join(', ')}${missingPdrs.length > 10 ? '...' : ''}.`
            )
            return
          }

          await utilityService.generaFileBonusBasilicataRisposta(
            getBonusRispostaDate().format('YYYY-MM-DD'),
            file
          )
          bonusRispostaImportato.value = true
          showToast('success', 'File generato', `Download ${moment(selectedDataRispostaBonus.value).format('MM/YYYY')} avviato.`)
        } catch (err) {
          const responseData = err?.response?.data
          showToast('warn', 'Errore', responseData?.message || 'Impossibile elaborare il file caricato.')
        } finally {
          loader.value = false
          bonusRispostaUploadKey.value += 1
        }
      }

      const downloadBonusRisposta = async () => {
        try {
          if (!validateBonusRispostaDate()) {
            showToast('warn', 'Mensilita non valida', 'La mensilita puo arrivare al massimo al mese corrente meno due mesi.')
            return
          }

          loader.value = true
          await utilityService.scaricaFileBonusBasilicataRisposta(getBonusRispostaDate().format('YYYY-MM-DD'))
          showToast('success', 'Download avviato', `Download ${moment(selectedDataRispostaBonus.value).format('MM/YYYY')} avviato.`)
        } catch (err) {
          const responseData = err?.response?.data
          showToast('warn', 'Errore', responseData?.message || 'Impossibile scaricare il file richiesto.')
        } finally {
          loader.value = false
        }
      }

      const exportCSV = (tableName) => {
        let data = [];
        let columns = [];
        let filename = 'export.csv';
        
        if (tableName === 'dtBonus') {
          data = itemsBonus.value;
          columns = columnsBonus.value;
          filename = nome_dt_bonus.value + '.csv';
        } else if (tableName === 'dtFatture') {
          data = itemsFatture.value;
          columns = columnsFatture.value;
          filename = nome_dt_fatture.value + '.csv';
        } else {
          return;
        }
        
        const headers = columns.join(';');
        
        const rows = data.map(row => {
          return columns.map(colField => {
            const cellValue = row[colField] !== undefined && row[colField] !== null ? row[colField] : '';
            let stringValue = cellValue.toString().trim();
            if (colField === 'PDR') {
              return stringValue;
            }
            if ((stringValue.startsWith('0') && !isNaN(stringValue) && stringValue.length > 0) || (stringValue.includes(',') || stringValue.includes(';'))) stringValue = `"${stringValue}"`
            
            return stringValue;
          }).join(';');
        });
        
        const csvContent = [headers, ...rows].join('\r\n');
        
        const BOM = '\uFEFF';
        const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' });
        const link = document.createElement('a');
        
        link.href = URL.createObjectURL(blob);
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      };
      
      return { 
        loader,
        itemsBonus,
        columnsBonus,
        itemsFatture,
        columnsFatture,
        exportCSV,
        dtBonus,
        dtFatture,
        selectedDataEmissione,
        includeConsumi,
        maxDate,
        getDataFatture,
        nome_dt_fatture,
        nome_dt_bonus,
        moment,
        selectedDataBonus,
        maxDateBonus,
        getDataBonus,
        selectedDataRispostaBonus,
        maxDateRispostaBonus,
        nome_file_risposta_bonus,
        bonusRispostaUploadKey,
        bonusRispostaImportato,
        uploadBonusRisposta,
        downloadBonusRisposta,
        getInvoiceNumber,
        openFatturaPdf,
        downloadFattureZip,
        downloadFattureEsteseZip
      }
    }
  }
</script>
<style>
</style>
